export default "__VITE_ASSET__Cphuhs_6__"